import { jsx as _jsx } from "react/jsx-runtime";
import MessageLists from './MessageList';
export function MessageList({ msgTypeId, tabItems }) {
    return _jsx(MessageLists, { msgTypeId: msgTypeId, tabItems: tabItems });
}
